import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

interface UserGrowthChartProps {
  dailyActiveUsers: number;
  weeklyActiveUsers: number;
  monthlyActiveUsers: number;
  title?: string;
  description?: string;
}

export function UserGrowthChart({
  dailyActiveUsers,
  weeklyActiveUsers,
  monthlyActiveUsers,
  title = "Active Users Overview",
  description = "Daily, weekly, and monthly active user trends"
}: UserGrowthChartProps) {
  // Create mock trend data (in real app, this would come from backend)
  const chartData = [
    { period: 'DAU', value: dailyActiveUsers, color: '#526ac9' },
    { period: 'WAU', value: weeklyActiveUsers, color: '#10b981' },
    { period: 'MAU', value: monthlyActiveUsers, color: '#8b5cf6' },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={250}>
          <AreaChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
            <XAxis
              dataKey="period"
              className="text-xs"
              tick={{ fill: 'hsl(var(--muted-foreground))' }}
            />
            <YAxis
              className="text-xs"
              tick={{ fill: 'hsl(var(--muted-foreground))' }}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'hsl(var(--popover))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '8px',
              }}
            />
            <Area
              type="monotone"
              dataKey="value"
              stroke="hsl(var(--primary))"
              fill="hsl(var(--primary) / 0.2)"
              strokeWidth={2}
            />
          </AreaChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
